import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import i18n from '@/language'
import arr from '@/service/arrayPrototype.service'

/**
 * Include any dependencies modules.
 */
import Moment from 'moment'
import Validate from 'vee-validate'
import Title from '@/components/Title/index.vue'
import Modal from '@/components/Modal/index.vue'
import Select from '@/components/Select/index.vue'
const components: any = {
  Title,
  Modal,
  Select
}

/**
 * Installation global components.
 */
for (const key in components) Vue.component(key, components[key])

/**
 * Instanced config.
 */
Vue.use(Validate)
Vue.prototype.$m = Moment
Vue.config.productionTip = false
Vue.config.devtools = process.env.NODE_ENV !== 'production'

/**
 * Vue instance.
 */
new Vue({
  router,
  store,
  i18n,
  beforeCreate () {
    arr()
    console.info('🚀 Application Running...')
  },
  render: h => h(App)
}).$mount('#app')